export default {
  USE_COUPON_REQUEST: '@COUPON/USE_COUPON_REQUEST',
  USE_COUPON_SUCCESS: '@COUPON/USE_COUPON_SUCCESS',
  USE_COUPON_FAILURE: '@COUPON/USE_COUPON_FAILURE',
} as const